<template>
  <div :class="pageClass">
    <div class="report-header d-flex flex-row justify-content-between align-items-center bg-faded p-3">
      <div>
        <img src="/static/img/logo-lg.png" class="report-logo">
      </div>
      <div class="col-md-auto">
        <h2>{{ 'Welding Report' | translate }}</h2>
      </div>
      <div>
        <p>{{ currentDate }}</p>
      </div>
    </div>
    <div class="report-body p-3 row" v-if="reportRows" v-for="rr in reportRows">
        <div class="col-md-6">
          <table class="vuetable table table-striped w-100">
            <tbody class="vuetable-body">
              <tr v-if="0">
                <td><b> {{ 'Joint ID' | translate }} </b></td>
                <td> {{ rr.joint_id }} </td>
              </tr>
              <tr v-if="0">
                <td><b> {{ 'Joint ID' | translate }} </b></td>
                <td> {{ rr.name + rr.stored}} </td>
              </tr>
              <tr>
                <td><b> {{ 'Machine ID' | translate }} </b></td>
                <td> {{ rr.name }} </td>
              </tr>
              <tr v-if="rr.skarv_id">
                <td><b> {{ 'Skarv-ID' | translate }} </b></td>
                <td> {{ rr.skarv_id }} </td>
              </tr>
              <tr v-if="0">
                <td><b> {{ 'stored' | translate }} </b></td>
                <td> {{ rr.stored }} </td>
              </tr>
              <tr>
                <td><b> {{ 'dimension' | translate }} </b></td>
                <td> {{ rr.dimension }} </td>
              </tr>
              <tr>
                <td><b> {{ 'timestamp' | translate }} </b></td>
                <td> {{ rr.datetime }} </td>
              </tr>
              <tr>
                <td><b> {{ 'u_mains' | translate }} </b></td>
                <td> {{ rr.u_mains }} </td>
              </tr>
              <tr v-if="rr.u_mains_min || rr.u_mains_max">
                <td><b> {{ 'u_mains_min_max' | translate }} </b></td>
                <td> {{ rr.u_mains_min }} / {{ rr.u_mains_max }} </td>
              </tr>
              <tr>
                <td><b> {{ 'mode' | translate }} </b></td>
                <td> {{ rr.mode }} </td>
              </tr>
              <tr>
                <td><b> {{ 'channel' | translate }} </b></td>
                <td> {{ rr.channel }} </td>
              </tr>
              <tr>
                <td><b> {{ 'alarm' | translate }} </b></td>
                <td> {{ 'ALARM-' + rr.alarm | translate }} </td>
              </tr>
              <tr>
                <td><b> {{ 'processDone' | translate }} </b></td>
                <td> {{ rr.weld_status | translate }} </td>
              </tr>
              <tr v-if="0">
                <td><b> {{ 'temps' | translate }} </b></td>
                <td> <span>{{ rr.temps.filter(Boolean).join(', ') }} </span></td>
              </tr>
              <tr>
                <td><b> {{ 'joint_time_a' | translate }} </b></td>
                <td> {{ calcJointTime(rr.joint_time_a) }} </td>
              </tr>
              <tr>
                <td><b> {{ 'GPS Position' | translate }} </b></td>
                <td>
                  <span v-if="rr.latitude < 9999" v-html="getDMS(rr.latitude, 'latitude') + ', ' + getDMS(rr.longitude, 'longitude')"></span>
                  <span v-if="rr.latitude > 9998">Not available</span>
                </td>
              </tr>
              <tr v-if="rr.oper_id">
                <td><b> {{ 'Operator ID' | translate }} </b></td>
                <td> {{ rr.oper_id }} </td>
              </tr>
              <tr v-if="rr.comment">
                <td><b> {{ 'Joint Comment' | translate }} </b></td>
                <td> {{ rr.comment }} </td>
              </tr>

            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          <joint-map :enableOverlay="false" :zoom="14" mapStyle="min-width: 526px" :joints="reportRows"></joint-map>
          <template v-if="!(rr.mode == 1 && rr.dimension < 280)">
            <h6 class="mt-4">{{ 'Temperature' | translate }}</h6>
            <temp-curve-chart class="chart-wrapper" :chartData="prepDataset(rr.temps)" style="height:280px;" height="300"></temp-curve-chart>
          </template>
        </div>
      </div>
    <div class="report-footer bg-faded p-2">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <p>
            <b>{{ 'Created by:' | translate }}</b> {{ currentUser.firstname }} {{ currentUser.surname }}</br>
            <b>{{ 'Company:' | translate }}</b> {{ companyName }}
            <span v-if="currentReportName">
              </br>
              <b>{{ 'Report Name:' | translate }}</b> {{ currentReportName }}</br>
            </span>
          </p>
        </div>
        <div>
          <p><b>{{ 'Page:' | translate }}</b> {{ pageNo + 1 }} {{ 'of' | translate }} {{ noOfPages + 1 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TempCurveChart from '../components/TempCurveChart'
import JointMap from './JointMap'
import JointMixin from '../mixins/JointMixin'

export default {
  components: {
    TempCurveChart,
    JointMap
  },
  mixins: [JointMixin],
  props: ['reportRows', 'pageNo', 'noOfPages'],
  data: function () {
    return {
      labels: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, this.$t('Minutes')],
      currentDate: null
    }
  },
  computed: {
    ...mapGetters([
      'currentCompany',
      'currentUser',
      'currentReportName'
    ]),
    pageClass: function () {
      return 'report-page page-' + this.pageNo
    },
    companyName: function () {
      return this.$store.getters.currentUser.companies.find(x => x.id === this.$store.getters.currentCompany).name
    }
    /* isAdmin: function () {
      return this.$store.getters.currentUser.role.indexOf('admin') >= 0
    } */
  },
  mounted: function () {
    var cd = new Date()
    this.currentDate = cd.toUTCString()
  },
  methods: {
    getDMS: function (coordinate, latlong) {
      var direction = ''
      if (latlong === 'latitude') {
        if (coordinate > 0) {
          direction = 'N'
        } else {
          direction = 'S'
        }
      } else if (latlong === 'longitude') {
        if (coordinate > 0) {
          direction = 'E'
        } else {
          direction = 'W'
        }
      }

      var degrees = parseInt(coordinate / 100)
      var minutes = coordinate - (degrees * 100)
      var seconds = (minutes - parseInt(minutes)) * 60
      return direction + ' ' + degrees + '&deg;' + parseInt(minutes) + '&rsquo;' + this.roundTo(seconds, 3) + '&rdquo;'
    },
    processDone: function (alarm) {
      if (alarm !== 0) {
        return 'No'
      } else {
        return 'Yes'
      }
    },
    columnName: function (key) {
      return 'column-' + key
    },
    roundTo (value, decimal) {
      let absValue = Math.abs(value)
      let int = Math.floor(absValue).toString().length
      let dec = absValue.toString().length - int
      dec -= (Number.isInteger(absValue) ? 0 : 1)
      return value.toPrecision(int + Math.min(dec, decimal))
    }
  },
  filters: {
    filterThat: function (val, key) {
      if (key === 'name') {
        return val.slice(-3)
      } else {
        return val
      }
    }
  }
}
</script>
<style>

.chart-wrapper { 
  margin-top: 0 !important; 
}

.report-page {
  border: 1px solid #f0f0f0
}

.report-logo {
  max-width: 100px;
}

.report-header {
  height: 30mm
}

.report-body {
  height: 160mm
}

.report-body td {
  padding: 0.3rem;
}

.report-footer {
  height: 20mm
}

.column-latitude, .column-longitude, .column-weld_id {
  display: none
}

</style>


// WEBPACK FOOTER //
// JointReportPage.vue?612270a2